module.exports = __webpack_public_path__ + "static/media/footballPitch.b31462fd.png";